import { useState, useEffect, useRef } from 'react'
import api from '@api'
import { UseEmployeesHook, getVariables } from './useEmployees'
import { Toaster } from '@ui'
import { ApolloError } from 'apollo-boost'
import { useFileDownload } from '@hooks'
import track from '@track'

export default function useEmployeeExport(employees: UseEmployeesHook, onClose: () => void) {
  const unmounted = useRef(false)
  const startFileDownload = useFileDownload()
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    function checkProgress(exportId: string) {
      api.employee
        .checkExportStatus({ exportId })
        .then((exportStatus) => {
          if (unmounted.current) return

          if (exportStatus.url) {
            startFileDownload(exportStatus.url)
            track.employees({
              eventName: track.Event.EXPORT,
            })
            setProgress(1)
            onClose()
          } else {
            setProgress(exportStatus.progress / exportStatus.total)
            setTimeout(() => checkProgress(exportId), 1000)
          }
        })
        .catch((error: ApolloError) => Toaster.fail({ error }))
    }

    const input = getVariables({
      sort: employees.sort,
      filters: employees.filters,
    })

    api.employee
      .createExport(input)
      .then(({ id, url }) => {
        if (unmounted.current) return

        if (url) {
          startFileDownload(url)
          track.employees({
            eventName: track.Event.EXPORT,
          })
          setProgress(1)
          onClose()
        } else if (id) {
          checkProgress(id)
        }
      })
      .catch((error: ApolloError) => Toaster.fail({ error }))

    return () => {
      unmounted.current = true
    }
  }, [employees.filters, employees.sort, startFileDownload, onClose])

  return {
    progress,
    reset() {
      startFileDownload('')
      setProgress(0)
    },
  }
}
